import React from 'react'

export const getFonts = () => {
  let fontClassName: string
  let fontScriptElement: JSX.Element | undefined

  switch (process.env.GATSBY_SANITY_DATASET) {
    case 'eqt-china-prod':
      fontClassName = 'font-cn'

      // Source Han Sans Simplified Chinese - https://fonts.adobe.com/fonts/source-han-sans-simplified-chinese
      fontScriptElement = (
        <script>
          {`
            (function(d) {
              var config = {
                kitId: 'ccu8zmn',
                scriptTimeout: 3000,
                async: true
              },
              h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
            })(document);
          `}
        </script>
      )
      break
    case 'eqt-japan-prod':
      fontClassName = 'font-jp'

      // Noto Sans CJK JP - https://fonts.adobe.com/fonts/noto-sans-cjk-jp
      fontScriptElement = (
        <script>
          {`
            (function(d) {
              var config = {
                kitId: 'ytz5sva',
                scriptTimeout: 3000,
                async: true
              },
              h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
            })(document);
          `}
        </script>
      )
      break
    case 'eqt-korea-prod':
      fontClassName = 'font-kr'

      // Noto Sans CJK KR - https://fonts.adobe.com/fonts/noto-sans-cjk-kr
      fontScriptElement = (
        <script>
          {`
            (function(d) {
              var config = {
                kitId: 'ohv3ghh',
                scriptTimeout: 3000,
                async: true
              },
              h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
            })(document);
          `}
        </script>
      )
      break
    default:
      fontClassName = 'font-default'
      break
  }

  return {
    fontClassName,
    fontScriptElement,
  }
}
